import { RequestService } from '../../../../../common/services/RequestService';
import { TINTS_GET } from '../../constants';

export const getTintsRequest = payload => {
  return RequestService.get(TINTS_GET);
};
